import React, { useState } from 'react';
import { DownCircleFilled } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '@BUP/hooks';
import Menu from './Menu';

const UserInfo = () => {
  const { user } = useAuth();
  const [showMenu, setShowMenu] = useState(false);

  return (
    <div className="user-info-container">
      <div className="user-info-element">
        <h4 className="user-name">{user?.name || 'Sin Nombre'}</h4>
        <h4 className="user-profession">{user?.roles?.name || 'Sin Cargo'}</h4>
      </div>
      <div className="user-info-icons">
        <FontAwesomeIcon className="user-icon" icon={faUserCircle} />
        <DownCircleFilled
          className={`arrow-icon ${showMenu ? 'icon-active' : ''}`}
          onClick={() => setShowMenu(!showMenu)}
        />
      </div>
      {showMenu ? (
        <Menu user={user} closeMenu={() => setShowMenu(false)} />
      ) : null}
    </div>
  );
};

export default UserInfo;
